import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RackAdapter } from './dto/racks.adapter';
import { RacksController } from './racks.controller';
import { Rack } from './racks.entity';
import { RacksService } from './racks.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Rack]),
  ],
  controllers: [RacksController],
  providers: [RacksService,RackAdapter,ApplicationExceptionHandler,LogsService]
})
export class RacksModule {}
